import React from "react";
import PropTypes from "prop-types";

/**
 * <CampaignItem />
 * 		Campaign Item property for the given UI
 * 			Used in the Campaign Info Header to build the individual groups of data for a Campaign
 * @param {object} props Top + Value properties
 */
export default function InfoItem(props){
	return (
		<article className={`camp-item ${props.className}`}>
			<span className="label blank-load">{props.top}</span>
			<span className="value blank-load">{props.value}</span>
		</article>
	);
}

InfoItem.displayName = "InfoItem";
InfoItem.defaultProps = {
	className:"",
	top:"",
	value:"",
};
InfoItem.propTypes = {
	className:PropTypes.string,
	top:PropTypes.node.isRequired,
	value:PropTypes.node.isRequired,
};
